import moment from "moment";
import dayjs from "dayjs";

export const formatDates = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  return moment(date).format("YYYY-MM-DD[T]HH:mm:ss");
};

export function formatDateNotTimeZone(
  date: Date | string | null | undefined
): string {
  if (date === null || date === undefined) {
    return "";
  }
  return moment(date).format("YYYY-MM-DD[T]HH:mm:ss");
}

export const formatDateTransfer = (
  dateString: string | Date | undefined | null,
  house: number = 0
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(house, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("DD-MM-YYYY HH:mm:ss");
};

export const formatDateTransferLastYear = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("DD-MM-YY HH:mm:ss");
};

export const formatDateTime = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 1900) return "";
  return moment(date).format("DD-MM-YYYY");
};

export const formatToReverseDate = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 1900) return "";
  return moment(date).format("YYYY-MM-DD");
};


export const formatNgayThangNam = (dateStr: string): string => {
  // Hỗ trợ cả "DD-MM-YYYY" và "YYYY-MM-DD"
  let day = "", month = "", year = "";
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    // "DD-MM-YYYY"
    [day, month, year] = dateStr.split("-");
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    // "YYYY-MM-DD"
    [year, month, day] = dateStr.split("-");
  } else {
    // Nếu không đúng format, thử parse bằng Date
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) {
      day = String(d.getDate());
      month = String(d.getMonth() + 1);
      year = String(d.getFullYear());
    }
  }
  return `ngày ${day} tháng ${month} năm ${year}`;
}